import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import AuthPage from './pages/AuthPage';
import Dashboard from './pages/Dashboard';
import MentionsLegales from './pages/MentionsLegales';
import PasswordRecovery from './pages/PasswordRecovery';
import MobilePaymentApp from './pages/MobilePaymentApp';
import InstallAppGuide from './pages/InstallAppGuide';
import PaymentTerminalSimulator from './pages/PaymentTerminalSimulator';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = React.useState(false);

  React.useEffect(() => {
    const token = localStorage.getItem('token');
    setIsAuthenticated(!!token);

    // Enregistrer le service worker pour la PWA
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/service-worker.js')
        .then(registration => console.log('SW registered:', registration))
        .catch(error => console.log('SW registration failed:', error));
    }
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/password-recovery" element={<PasswordRecovery />} />
        <Route path="/install-app" element={<InstallAppGuide />} />
        <Route path="/tpe-simulator" element={<PaymentTerminalSimulator />} />
        <Route 
          path="/mobile-pay" 
          element={isAuthenticated ? <MobilePaymentApp /> : <Navigate to="/auth" replace />} 
        />
        <Route 
          path="/dashboard/*" 
          element={isAuthenticated ? <Dashboard /> : <Navigate to="/auth" replace />} 
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
